import moment from "moment"

export function dateToString(date) {
	return moment(date).utc().format("YYYY-MM-DD HH:mm:ss")
}